




import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class ReadingTask3 extends Vue {}
